import { TRegions, IRegion } from './types';
import memoizee from 'memoizee';
import Regions from '.';
import { Logger } from 'src/app/services/logger.service';

export const getTheCheapestPremiumShippingRegion = memoizee(
  (regions: TRegions): IRegion => {
    return regions.reduce(
      (_prevRegion, _region) =>
        _region.fee.premiumShipping < _prevRegion.fee.premiumShipping
          ? _region
          : _prevRegion,
    );
  }
);

const getRegionByNameHiraganaLog = new Logger('getRegionByNameHiragana');
export const getRegionByNameHiragana = (
  nameHiragana: IRegion['nameHiragana']
) => {
  const log = getRegionByNameHiraganaLog;
  const region = Regions.find(
    _region => _region.nameHiragana === nameHiragana,
  );

  if (!region) {
    log.error('region not found by', { nameHiragana });
  }

  return region;
};

const getRegionByNameEnglishLog = new Logger('getRegionByNameEnglish');
export const getRegionByNameEnglish = (
  nameEnglish: IRegion['nameEnglish']
) => {
  const log = getRegionByNameEnglishLog;
  const region = Regions.find(
    _region => _region.nameEnglish === nameEnglish,
  );

  if (!region) {
    log.error('region not found by', { nameEnglish });
  }

  return region;
};
